import { css } from '@emotion/react'
import styled from '@emotion/styled'

const wrapperStyles = ({ theme }) => css`
  label: assisted-sale-wrapper;

  display: flex;
  flex-flow: column nowrap;
  align-items: center;

  width: 100%;

  padding: ${theme.spacings.mega};

  > div {
    margin-bottom: ${theme.spacings.mega};
  }
`

export const Wrapper = styled('div')(wrapperStyles)
